import router from '@/router';
import { isObject } from '@/utils/inspect';

let message;

export default err => {
	if (err.response) {
		const resp = err.response;
		console.log(resp);
		if (resp.status == 401) {
			router.push({ name: 'access-denied' });
		}
		if (
			typeof resp.data === 'string' &&
			resp.data &&
			resp.data.indexOf('TimeoutException') > -1
		) {
			message = 'timeout';
		} else {
			if (resp.status == 409) {
				throw { statusCode: resp.status, message: resp.data.message };
			}
			message = resp.data.message ? resp.data.message : resp.data.title;
		}
	} else if (
		isObject(err) &&
		err.message &&
		err.message.indexOf('timeout') > -1
	) {
		message = 'timeout';
	} else if (
		isObject(err) &&
		err.message &&
		err.message.indexOf('499') > -1
	) {
		message = err.message;
	} else if (err.request) {
		console.log(err.request);
		message = err.request;
	} else if (err instanceof Error) {
		console.log(err.message);
		message = err.message;
	} else if (typeof err === 'string') {
		console.log(err);
		message = err;
	} else {
		console.log(
			'There was some Problem with your Request, Please Try again Later'
		);
	}

	throw message;
};
